/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_UsersInputs */

const es_tools_nexata_list_users = /** @type {(inputs: Tools_Nexata_List_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando usuarios...`)
};

const en_tools_nexata_list_users = /** @type {(inputs: Tools_Nexata_List_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching users...`)
};

/**
* | output |
* | --- |
* | "Fetching users..." |
*
* @param {Tools_Nexata_List_UsersInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_users = /** @type {((inputs?: Tools_Nexata_List_UsersInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_UsersInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_users(inputs)
	return en_tools_nexata_list_users(inputs)
});
export { tools_nexata_list_users as "tools.nexata.list_users" }